<template>
    <div class="ah-page petty-cash-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>零用現金</h1>
                        <el-select v-model="queryParams.Year" placeholder="年度" class="title-dropdown" @change="updateData">
                            <el-option v-for="year in yearList" :key="year" :label="year" :value="year" />
                        </el-select>
                    </div>
                    <div class="actions">
                        <el-button type="highlight" @click="importDialogVisible = true">轉入零用現金</el-button>
                        <el-button type="dark" @click="exportDialogVisible = true">轉出零用現金</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-color">
            <div class="ah-container">
                <el-row :gutter="20">
                    <el-col :sm="14">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">即時餘額 ({{ todayText }})</div>
                                <div class="statis-num">
                                    <Money :v="Math.round(totalAmount)" />
                                </div>
                            </div>
                        </div>
                        <el-row :gutter="20">
                            <el-col :sm="12">
                                <div class="ah-card main-color">
                                    <div class="content">
                                        <div class="statis-title">{{ queryParams.Year }} 年 零用現金「轉入」總額</div>
                                        <div class="statis-num">
                                            <Money :v="Math.round(statistics.transferInAmount)" />
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :sm="12">
                                <div class="ah-card main-color">
                                    <div class="content">
                                        <div class="statis-title">{{ queryParams.Year }} 年 零用現金「轉出」總額</div>
                                        <div class="statis-num">
                                            <Money :v="Math.round(statistics.transferOutAmount)" />
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :sm="12">
                                <div class="ah-card main-color">
                                    <div class="content">
                                        <div class="statis-title">{{ queryParams.Year }} 年 發票入帳</div>
                                        <div class="statis-num">
                                            <Money :v="Math.round(statistics.invoiceTransferInAmount)" />
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :sm="12">
                                <div class="ah-card main-color">
                                    <div class="content">
                                        <div class="statis-title">{{ queryParams.Year }} 年 發票退款</div>
                                        <div class="statis-num">
                                            <Money :v="Math.round(statistics.invoiceTransferOutAmount)" />
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :sm="10">
                        <div class="ah-card main-color">
                            <div class="content">
                                <div class="statis-title">
                                    {{ queryParams.Year }} 年 請款單「請款總額」
                                    <ahTip>含代扣所得税、二代健保</ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="Math.round(statistics.paymentTransferOutAmount)" />
                                </div>
                            </div>
                            <div class="content" style="margin-top: 25px">
                                <div class="statis-title">
                                    {{ queryParams.Year }} 年 請款單「實付總額」
                                    <ahTip>不含代扣所得税、二代健保</ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="Math.round(statistics.untaxedPaymentTransferOutAmount)" />
                                </div>
                            </div>
                            <div class="content" style="margin-top: 25px">
                                <div class="statis-title">
                                    {{ queryParams.Year }} 年 發票入帳淨額
                                    <ahTip>發票入帳 - 發票退款</ahTip>
                                </div>
                                <div class="statis-num">
                                    <Money :v="Math.round(statistics.invoiceTransferInAmount - statistics.invoiceTransferOutAmount)" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="ah-container" style="margin-top: 25px">
            <div class="ah-panel">
                <div style="padding: 10px">
                    <div class="ah-tabs center">
                        <div
                            v-for="(tab, index) in tabList"
                            :key="`tab-${index}`"
                            class="item"
                            :class="{
                                'name-only': tab.nameOnly,
                                active: queryParams.QueryTabNo === tab.QueryTabNo
                            }"
                            @click="changeTab(tab.QueryTabNo)"
                        >
                            <span class="name no-padding">
                                <span class="type-label" :class="tab.class">{{ tab.label }}</span>
                            </span>
                            <span class="count">
                                {{ statistics[tab.fieldName] }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <el-table v-loading="status == 'loading'" :data="datas" style="width: 100%" class="ah-el-data-table" empty-text="沒有資料">
                        <el-table-column label="日期" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.dat | dateFormater("YYYY-MM-dd") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="類型" width="120">
                            <template slot-scope="scope">
                                <span>
                                    <span class="type-label" :class="getTypeClass(scope.row.typ)">
                                        {{ getTypeLabel(scope.row.typ) }}
                                    </span>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="summary" label="摘要" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div v-if="scope.row.nam">{{ scope.row.nam }}</div>
                                <div v-else>{{ scope.row.summary }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="bnK_NAM" label="銀行帳戶" width="130">
                            <template slot-scope="scope">
                                <div class="strong" v-if="scope.row.bnK_NAM">
                                    {{ scope.row.bnK_NAM }}
                                </div>
                                <div v-else style="opacity: 0.4">(無)</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="mem" label="備註" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-button type="text" v-if="scope.row.typ == 999" @click="openPayment(scope.row.mem)">
                                    {{ scope.row.mem }}
                                </el-button>
                                <el-button type="text" v-else-if="scope.row.typ == 3 || scope.row.typ == 4" @click="openInvoice(scope.row.mem)">
                                    {{ scope.row.mem.split(",")[1] }}
                                </el-button>
                                <el-button type="text" v-else-if="scope.row.typ == 5" @click="openVariable(scope.row.sno)">
                                    {{ scope.row.mem }}
                                </el-button>
                                <div v-else style="color: #aaa; font-size: 10pt">
                                    {{ scope.row.mem }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="upD_USR" label="操作人員" width="110" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span v-if="scope.row.upD_USR"> {{ scope.row.upD_USR }} </span>
                                <span v-else-if="scope.row.crT_USR"> {{ scope.row.crT_USR }} </span>
                                <span v-else style="color: #aaa; font-size: 10pt">
                                    系統自動產生
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="amt" width="120" label="請領金額" align="right">
                            <template slot-scope="scope">
                                <Money :v="scope.row.amt" />
                            </template>
                        </el-table-column>
                        <el-table-column label="動作" align="center" width="80">
                            <template slot-scope="scope">
                                <el-button size="small" v-if="scope.row.typ == 1 || scope.row.typ == 2" @click="handleEditClick(scope.row)">編輯</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        :small="isMobile()"
                        @current-change="updateData"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <ImportDialog :visible="importDialogVisible" :inputData="importDialogData" :isInitial="isNoDataYet === true" @close="closeImportDialog" />
        <ExportDialog :visible="exportDialogVisible" :inputData="exportDialogData" @close="closeExportDialog" />
        <PaymentDetailDialog @close="handlePaymentDetailDialogClose" :visible="paymentDetailDialog.visible" :sno="paymentDetailDialog.sno" />
        <InvoiceDetailDialog @close="handleInvoiceDetailDialogClose" :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" />
        <VariableDetailDialog @close="handleVariableDetailDialogClose" :visible="variableDetailDialog.visible" :sno="variableDetailDialog.sno" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import PaymentDetailDialog from '@/components/dashboard/Payment/PaymentDetailDialog.vue';
import InvoiceDetailDialog from '@/components/dashboard/Invoice/InvoiceDetailDialog.vue';
import VariableDetailDialog from '@/components/dashboard/Finance/VariableStatement/DetailDialog.vue';
import { PettyCashLabelOptions } from '@/assets/commonData/options';
import ImportDialog from './ImportDialog.vue';
import ExportDialog from './ExportDialog.vue';

export default {
    components: {
        ImportDialog,
        ExportDialog,
        PaymentDetailDialog,
        InvoiceDetailDialog,
        VariableDetailDialog,
    },
    data() {
        return {
            isNoDataYet: false,
            importDialogVisible: false,
            importDialogData: null,
            exportDialogVisible: false,
            exportDialogData: null,
            queryParams: {
                QueryTabNo: 1,
                PageNum: 1,
                PageSize: 25,
                Year: null,
            },
            totalDataCount: 0,
            totalAmount: 0,
            statistics: {},
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },
            variableDetailDialog: {
                visible: false,
                sno: null,
            },
            status: '',
            datas: [],
            errorMsg: '',
            yearList: [],
            tabList: [
                {
                    typ: -1,
                    label: '全部',
                    QueryTabNo: 1,
                    class: '',
                    fieldName: 'allCount',
                    nameOnly: true,
                },
                ...PettyCashLabelOptions,
            ],
        };
    },
    computed: {
        todayText() {
            const date = new Date();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const year = date.getFullYear();
            return `${year}-${month}-${day}`;
        },
    },
    created() {
        // 確認是否有第一筆資金
        this.checkFirstFund();
        // 取得年份下拉項目
        this.initYearList();
        this.updateData();
    },
    methods: {
        async checkFirstFund() {
            const resp = await this.$api({
                url: 'FundManagementPage/GetList?PageNum=1&PageSize=1',
                method: 'GET',
            });

            if (resp.data.items.length === 0) this.isNoDataYet = true;
            else this.isNoDataYet = false;
        },
        async initYearList() {
            const THIS_YEAR = moment().year();
            for (let i = THIS_YEAR; i >= 2020; i -= 1) {
                this.yearList.push(i);
            }
            this.queryParams.Year = THIS_YEAR;
        },
        getTypeLabel(typ) {
            return _.find(PettyCashLabelOptions, ['typ', typ])?.label;
        },
        getTypeClass(typ) {
            return _.find(PettyCashLabelOptions, ['typ', typ])?.class;
        },
        openPayment(Payoo) {
            this.$api({
                url: '/FundManagementPage/GetPaymentInfo',
                params: {
                    Payoo,
                },
                method: 'GET',
            }).then((resp) => {
                if (resp.data.item) {
                    this.paymentDetailDialog.visible = true;
                    this.paymentDetailDialog.sno = resp.data.item.sno;
                }
            });
        },
        openInvoice(mem) {
            this.invoiceDetailDialog.visible = true;
            // eslint-disable-next-line prefer-destructuring
            this.invoiceDetailDialog.sno = mem.split(',')[0];
        },
        openVariable(sno) {
            this.variableDetailDialog.visible = true;
            this.variableDetailDialog.sno = sno;
        },
        isPaymentNo(text) {
            const re = /^PA[0-9]{9}/g;
            return text.match(re);
        },
        changeTab(tabNo) {
            this.queryParams.QueryTabNo = tabNo;
            this.queryParams.PageNum = 1;
            this.updateData();
        },

        handleEditClick(data) {
            console.log(data);
            if (data.typ === 1) {
                this.importDialogData = data;
                this.importDialogVisible = true;
            } else if (data.typ === 2) {
                this.exportDialogData = data;
                this.exportDialogVisible = true;
            }
        },
        closeImportDialog(refresh) {
            if (refresh) this.updateData();

            this.importDialogVisible = false;
            setTimeout(() => {
                this.importDialogData = null;
            }, 500);
        },

        closeExportDialog(refresh) {
            if (refresh) this.updateData();

            this.exportDialogVisible = false;
            setTimeout(() => {
                this.exportDialogData = null;
            }, 500);
        },

        async updateData() {
            this.status = 'loading';
            this.errorMsg = '';

            const resp = await this.$api({
                url: 'FundManagementPage/GetList',
                params: {
                    Year: this.queryParams.Year,
                    QueryTabNo: this.queryParams.QueryTabNo,
                    PageNum: this.queryParams.PageNum,
                    PageSize: this.queryParams.PageSize,
                },
                method: 'GET',
            });
            if (this.queryParams.PageNum !== 1 && !resp.data.totalNum) {
                this.queryParams.PageNum -= 1;
                this.updateData();
                return;
            }

            this.status = 'success';
            this.datas = resp.data.items;
            this.totalDataCount = resp.data.totalNum;
            this.totalAmount = resp.data.balance;
            this.statistics = { ...resp.data.statistics };

            if (this.datas.length > 0) this.isNoDataYet = false;
        },
        handleChangeDate() {
            this.updateData();
        },
        handlePaymentDetailDialogClose() {
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;
            this.updateData();
        },
        handleInvoiceDetailDialogClose() {
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
            this.updateData();
        },
        handleVariableDetailDialogClose() {
            this.variableDetailDialog.visible = false;
            this.variableDetailDialog.sno = null;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.petty-cash-page {
    .type-label {
        display: inline-block;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        border-radius: 12px;
        font-size: 9.5pt;
        color: #222;
        font-weight: 500;
        &.import {
            background-color: #cad1f1;
        }
        &.export {
            background-color: #c6ecc2;
        }
        &.arrival {
            background-color: #c1f365;
        }
        &.refund {
            background-color: #f5a85a;
        }
        &.export-payment {
            background-color: #ffe36c;
        }
        &.personnel-fee-payment {
            background-color: #dcc1fa;
        }
        &.salary-payment {
            background-color: #ffa0dc;
        }
    }
}
</style>
